(() => {
  if (customElements.get('csg-home-video-loader')) return;
  class HomeVideoLoader extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.video = this.querySelector('video[data-csg-video-src]');
      if (!this.video) return;
      this.connected = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.video.controls = false;
      this.video.removeAttribute('controls');
      this.video.muted = true;
      this.button = this.querySelector('[data-csg-load-video]');
      this.poster = this.querySelector('[data-csg-video-poster]');
      this.visible = false; this.near = false; this.playPending = false;
      this.playAttempt = 0; this.pauseReason = this.pauseReason || ''; this.autoBlocked = false;
      this.userPaused = Boolean(this.userPaused);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.button?.addEventListener('click', () => {
        if (!this.video.paused || this.playPending) {
          this.userPaused = true;
          this.pauseVideo('user');
        } else {
          this.userPaused = false; this.autoBlocked = false;
          if (this.video.ended) this.video.currentTime = 0;
          this.playVideo(true);
        }
      }, options);
      this.video.addEventListener('play', () => this.updateButton(), options);
      this.video.addEventListener('playing', () => {
        this.pauseReason = '';
        if (this.poster) this.poster.hidden = true;
        this.updateButton();
      }, options);
      this.video.addEventListener('pause', () => {
        // A pause outside our own visibility/policy handlers is intentional too
        // (for example an operating-system media key).
        if (!this.pauseReason && this.video.paused) this.userPaused = true;
        this.pauseReason = '';
        this.updateButton();
      }, options);
      this.video.addEventListener('ended', () => { this.userPaused = true; this.updateButton(); }, options);
      this.video.addEventListener('error', () => {
        this.autoBlocked = true;
        if (this.poster) this.poster.hidden = false;
        this.updateButton();
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.pauseVideo('policy'); else this.syncPlayback();
      }, options);
      this.connection?.addEventListener?.('change', () => {
        if (this.connection.saveData) this.pauseVideo('policy'); else this.syncPlayback();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      if ('IntersectionObserver' in window) {
        this.preloadObserver = new IntersectionObserver(entries => {
          this.near = entries.some(entry => entry.isIntersecting);
          if (this.near && this.canAutoplay()) this.activate();
        }, { rootMargin: '200px 0px', threshold: 0 });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.syncPlayback();
        }, { threshold: 0 });
        this.preloadObserver.observe(this); this.observer.observe(this);
      }
      if (this.button) this.button.hidden = false;
      this.updateButton();
    }
    canAutoplay() {
      return this.dataset.autoplay !== 'false' && !this.motion.matches && !this.connection?.saveData && !document.hidden && !this.userPaused && !this.autoBlocked && !this.video.ended;
    }
    activate() {
      if (!this.video.hasAttribute('src')) {
        this.video.src = this.video.dataset.csgVideoSrc;
        this.video.load();
      }
    }
    playVideo(manual = false) {
      if (!this.connected || document.hidden || this.playPending || (!manual && !this.canAutoplay())) return;
      this.activate();
      if (manual && this.video.error) this.video.load();
      this.playPending = true;
      const attempt = ++this.playAttempt;
      Promise.resolve(this.video.play()).catch(() => {
        if (attempt === this.playAttempt && !this.userPaused) this.autoBlocked = true;
      }).finally(() => {
        if (attempt === this.playAttempt) { this.playPending = false; this.updateButton(); }
      });
    }
    pauseVideo(reason) {
      this.playAttempt++; this.playPending = false;
      if (!this.video.paused) { this.pauseReason = reason; this.video.pause(); }
      this.updateButton();
    }
    syncPlayback() {
      if (!this.connected) return;
      if (!this.visible || document.hidden) this.pauseVideo('visibility');
      else if (this.canAutoplay() && this.video.paused) this.playVideo();
    }
    updateButton() {
      if (!this.button) return;
      const playing = !this.video.paused && !this.video.ended;
      this.button.dataset.state = playing ? 'playing' : 'paused';
      this.button.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
    }
    disconnectedCallback() {
      this.connected = false;
      this.observer?.disconnect(); this.preloadObserver?.disconnect();
      this.events?.abort();
      if (this.video) this.pauseVideo('disconnect');
    }
  }
  customElements.define('csg-home-video-loader', HomeVideoLoader);
})();
